import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';

import { DataTable } from '@/shared/presentation/components/ui/DataTable';
import { Page } from '@/shared/presentation/components/ui/Page';

import { OrganizationViewModel } from './Organization.vm';

const Applications = observer(() => {
  const vm = useViewModel(OrganizationViewModel);

  const columns = useMemo(
    () => [
      {
        name: 'Nome',
        selector: (row) => row.name || '',
        format: (row) => <Link to={`/admin/applications/${row.guid}`}>{row.name}</Link>,
        sortable: true,
        filterable: true,
      },
    ],
    [],
  );

  const data = vm.organization?.applications.map((application) => ({
    name: application.name,
  }));

  return (
    <div>
      <DataTable columns={columns} data={data} actions={[]} />
    </div>
  );
});

const OrganizationDetail = observer(() => {
  const vm = useViewModel(OrganizationViewModel);
  if (!vm.organization) {
    return null;
  }

  return (
    <div>
      <p>GUID: {vm.organization?.guid}</p>
      <p>Nome: {vm.organization?.name}</p>
      <p>Descrição: {vm.organization?.description}</p>
      <p>Aplicações (quantidade): {vm.organization?.applications?.length}</p>
    </div>
  );
});

export const OrganizationScreen = observer(() => {
  const params = useParams<{ guid: string }>();
  const vm = useViewModel(OrganizationViewModel, { guid: params.guid });

  return (
    <Page
      title={vm.organization?.name}
      subtitle={vm.organization?.description}
      isLoading={vm.isLoading}
      hasError={vm.hasError}
      errorMessage="Ocorreu um erro ao carregar a organização."
      tabs={[
        {
          label: 'Detalhes',
          content: <OrganizationDetail />,
        },
        {
          label: 'Aplicações',
          content: <Applications />,
        },
      ]}
    />
  );
});
